// extracted by mini-css-extract-plugin
export default {"container":"YJ-z","topReviewHeading":"ZJ-z","criticalReview":"_J-z","favorableReview":"aK-z","vsSeparator":"bK-z"};